import { AnimatePresence, motion } from "motion/react";
import { useEffect, useMemo, useState } from "react";

import {
    getOrCreateProdeUser,
    getProdeUserByEmail,
    getProdeUserByUsername,
    getProdeMatches,
    getRanking,
    getUserPredictions,
    upsertPrediction,
    syncProdeMatches,
} from "../services/prodeService";

import imgMundial from "../assets/mundial.svg";

/* function imgMundial1() {
    return (
        <img
            src={imgMundial}
            alt="Team Stacy Logo"
            className="h-auto w-[110px] object-contain sm:w-[150px] lg:w-[220px]"
        />
    );
} */

type ProdeUser = {
    id: string;
    username: string;
    email: string;
};

type ProdeMatch = {
    id: string;
    stage: string;
    team_a: string;
    team_b: string;
    team_a_crest?: string | null;
    team_b_crest?: string | null;
    team_a_tla?: string | null;
    team_b_tla?: string | null;
    date: string;
    result_a: number | null;
    result_b: number | null;
    status: "Por jugar" | "En vivo" | "Finalizado" | "scheduled" | "live" | "finished" | string;
};

type Prediction = {
    id: string;
    user_id: string;
    match_id: string;
    pred_a: number;
    pred_b: number;
};

type RankingItem = {
    user_id?: string;
    username?: string;
    name?: string;
    points: number;
};

type RegisterFieldErrors = {
    username: string;
    email: string;
};

type LoginFieldErrors = {
    email: string;
};

const STORAGE_KEY = "stacy-prode-user";
const RANKING_PAGE_SIZE = 10;
const smoothEase = [0.22, 1, 0.36, 1] as const;



const WORLD_CUP_2026_FLAG_CODES: Record<string, string> = {
    // Hosts / CONCACAF
    CAN: "ca",
    CANADA: "ca",

    MEX: "mx",
    MEXICO: "mx",
    MÉXICO: "mx",

    USA: "us",
    UNITED_STATES: "us",
    UNITED_STATES_OF_AMERICA: "us",

    CUW: "cw",
    CUR: "cw",
    CURACAO: "cw",
    CURAÇAO: "cw",

    HAI: "ht",
    HAITI: "ht",
    HAITÍ: "ht",

    PAN: "pa",
    PANAMA: "pa",
    PANAMÁ: "pa",

    // CONMEBOL
    ARG: "ar",
    ARGENTINA: "ar",

    BRA: "br",
    BRAZIL: "br",
    BRASIL: "br",

    COL: "co",
    COLOMBIA: "co",

    ECU: "ec",
    ECUADOR: "ec",

    PAR: "py",
    PARAGUAY: "py",

    URY: "uy",
    URU: "uy",
    URUGUAY: "uy",

    // OFC
    NZL: "nz",
    NEW_ZEALAND: "nz",
    NUEVA_ZELANDA: "nz",

    // AFC
    AUS: "au",
    AUSTRALIA: "au",

    IRN: "ir",
    IRAN: "ir",
    IR_IRAN: "ir",

    JPN: "jp",
    JAPAN: "jp",
    JAPÓN: "jp",

    JOR: "jo",
    JORDAN: "jo",
    JORDANIA: "jo",

    QAT: "qa",
    QATAR: "qa",

    KSA: "sa",
    SAUDI_ARABIA: "sa",
    ARABIA_SAUDITA: "sa",

    KOR: "kr",
    SOUTH_KOREA: "kr",
    KOREA_REPUBLIC: "kr",
    COREA_DEL_SUR: "kr",

    UZB: "uz",
    UZBEKISTAN: "uz",
    UZBEKISTÁN: "uz",

    IRQ: "iq",
    IRAQ: "iq",
    IRAK: "iq",

    // CAF
    ALG: "dz",
    ALGERIA: "dz",
    ARGELIA: "dz",

    CPV: "cv",
    CAPE_VERDE: "cv",
    CABO_VERDE: "cv",

    EGY: "eg",
    EGYPT: "eg",
    EGIPTO: "eg",

    GHA: "gh",
    GHANA: "gh",

    CIV: "ci",
    COTE_D_IVOIRE: "ci",
    CÔTE_D_IVOIRE: "ci",
    IVORY_COAST: "ci",
    COSTA_DE_MARFIL: "ci",

    MAR: "ma",
    MOROCCO: "ma",
    MARRUECOS: "ma",

    SEN: "sn",
    SENEGAL: "sn",

    RSA: "za",
    SOUTH_AFRICA: "za",
    SUDÁFRICA: "za",
    SUDAFRICA: "za",

    TUN: "tn",
    TUNISIA: "tn",
    TÚNEZ: "tn",
    TUNEZ: "tn",

    COD: "cd",
    DRC: "cd",
    DR_CONGO: "cd",
    CONGO_DR: "cd",
    RD_CONGO: "cd",

    // UEFA
    AUT: "at",
    AUSTRIA: "at",

    BEL: "be",
    BELGIUM: "be",
    BÉLGICA: "be",
    BELGICA: "be",

    BIH: "ba",
    BOSNIA_AND_HERZEGOVINA: "ba",
    BOSNIA_HERZEGOVINA: "ba",
    BOSNIA: "ba",

    CRO: "hr",
    CROATIA: "hr",
    CROACIA: "hr",

    CZE: "cz",
    CZECHIA: "cz",
    CZECH_REPUBLIC: "cz",
    REPÚBLICA_CHECA: "cz",
    REPUBLICA_CHECA: "cz",

    ENG: "gb-eng",
    ENGLAND: "gb-eng",
    INGLATERRA: "gb-eng",

    FRA: "fr",
    FRANCE: "fr",
    FRANCIA: "fr",

    GER: "de",
    GERMANY: "de",
    ALEMANIA: "de",

    NED: "nl",
    NETHERLANDS: "nl",
    PAÍSES_BAJOS: "nl",
    PAISES_BAJOS: "nl",
    HOLANDA: "nl",

    NOR: "no",
    NORWAY: "no",
    NORUEGA: "no",

    POR: "pt",
    PORTUGAL: "pt",

    SCO: "gb-sct",
    SCOTLAND: "gb-sct",
    ESCOCIA: "gb-sct",

    ESP: "es",
    SPAIN: "es",
    ESPAÑA: "es",
    ESPANA: "es",

    SWE: "se",
    SWEDEN: "se",
    SUECIA: "se",

    SUI: "ch",
    SWITZERLAND: "ch",
    SUIZA: "ch",

    TUR: "tr",
    TURKIYE: "tr",
    TÜRKIYE: "tr",
    TURKEY: "tr",
    TURQUÍA: "tr",
    TURQUIA: "tr",
};

function normalizeTeamKey(value: string) {
    return value
        .trim()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/&/g, "AND")
        .replace(/[^A-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}

function getTeamFlagUrl(teamName: string) {
    const teamKey = normalizeTeamKey(teamName);
    const flagCode = WORLD_CUP_2026_FLAG_CODES[teamKey];

    if (!flagCode) {
        return null;
    }

    return `https://flagcdn.com/${flagCode}.svg`;
}

function TeamFlag({ team }: { team: string }) {
    const [hasImageError, setHasImageError] = useState(false);

    const teamKey = normalizeTeamKey(team);
    const flagUrl = getTeamFlagUrl(team);

    if (!flagUrl || hasImageError) {
        return (
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#181819]/10 font-['Roboto_Mono',monospace] text-[10px] font-bold uppercase text-[#181819]/60">
                {teamKey.slice(0, 2)}
            </span>
        );
    }

    return (
        <img
            src={flagUrl}
            alt={`Bandera de ${team}`}
            loading="lazy"
            onError={() => setHasImageError(true)}
            className="h-7 w-7 shrink-0 rounded-full border border-[#181819]/10 bg-white object-cover"
        />
    );
}

function ArrowIcon() {
    return (
        <svg className="shrink-0" width="20" height="20" viewBox="0 0 14 10" fill="none">
            <path
                d="M1 5H13M13 5L9 1M13 5L9 9"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </svg>
    );
}

function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim().toLowerCase());
}

function formatMatchDate(date: string) {
    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
        return "Fecha a confirmar";
    }

    return parsedDate.toLocaleDateString("es-AR", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
}

function normalizeStageKey(stage: string) {
    return stage
        .trim()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^A-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}

function formatStageLabel(stage: string) {
    const stageKey = normalizeStageKey(stage);

    const stageLabels: Record<string, string> = {
        GROUP_A: "GRUPO A",
        GROUP_B: "GRUPO B",
        GROUP_C: "GRUPO C",
        GROUP_D: "GRUPO D",
        GROUP_E: "GRUPO E",
        GROUP_F: "GRUPO F",
        GROUP_G: "GRUPO G",
        GROUP_H: "GRUPO H",
        GROUP_I: "GRUPO I",
        GROUP_J: "GRUPO J",
        GROUP_K: "GRUPO K",
        GROUP_L: "GRUPO L",

        GRUPO_A: "GRUPO A",
        GRUPO_B: "GRUPO B",
        GRUPO_C: "GRUPO C",
        GRUPO_D: "GRUPO D",
        GRUPO_E: "GRUPO E",
        GRUPO_F: "GRUPO F",
        GRUPO_G: "GRUPO G",
        GRUPO_H: "GRUPO H",
        GRUPO_I: "GRUPO I",
        GRUPO_J: "GRUPO J",
        GRUPO_K: "GRUPO K",
        GRUPO_L: "GRUPO L",

        LAST_32: "16AVOS",
        ROUND_OF_32: "16AVOS",

        LAST_16: "OCTAVOS",
        ROUND_OF_16: "OCTAVOS",

        QUARTER_FINALS: "CUARTOS",
        QUARTER_FINAL: "CUARTOS",
        QUARTERFINAL: "CUARTOS",
        CUARTOS: "CUARTOS",

        SEMI_FINALS: "SEMIFINAL",
        SEMI_FINAL: "SEMIFINAL",
        SEMIFINALS: "SEMIFINAL",
        SEMIFINAL: "SEMIFINAL",

        THIRD_PLACE: "TERCER PUESTO",
        THIRD_PLACE_GAME: "TERCER PUESTO",
        TERCER_PUESTO: "TERCER PUESTO",

        FINAL: "FINAL",
    };

    return stageLabels[stageKey] ?? stageKey.replace(/_/g, " ");
}

function getStageOrder(stage: string) {
    const stageKey = normalizeStageKey(stage);

    const stageOrder: Record<string, number> = {
        GROUP_A: 1,
        GROUP_B: 2,
        GROUP_C: 3,
        GROUP_D: 4,
        GROUP_E: 5,
        GROUP_F: 6,
        GROUP_G: 7,
        GROUP_H: 8,
        GROUP_I: 9,
        GROUP_J: 10,
        GROUP_K: 11,
        GROUP_L: 12,

        GRUPO_A: 1,
        GRUPO_B: 2,
        GRUPO_C: 3,
        GRUPO_D: 4,
        GRUPO_E: 5,
        GRUPO_F: 6,
        GRUPO_G: 7,
        GRUPO_H: 8,
        GRUPO_I: 9,
        GRUPO_J: 10,
        GRUPO_K: 11,
        GRUPO_L: 12,

        LAST_32: 13,
        ROUND_OF_32: 13,

        LAST_16: 14,
        ROUND_OF_16: 14,

        QUARTER_FINALS: 15,
        QUARTER_FINAL: 15,
        QUARTERFINAL: 15,
        CUARTOS: 15,

        SEMI_FINALS: 16,
        SEMI_FINAL: 16,
        SEMIFINALS: 16,
        SEMIFINAL: 16,

        THIRD_PLACE: 17,
        THIRD_PLACE_GAME: 17,
        TERCER_PUESTO: 17,

        FINAL: 18,
    };

    return stageOrder[stageKey] ?? 999;
}

function formatStatusLabel(status: string) {
    const normalizedStatus = status.trim().toLowerCase();

    if (normalizedStatus === "scheduled") return "Por jugar";
    if (normalizedStatus === "live") return "En vivo";
    if (normalizedStatus === "finished") return "Finalizado";

    return status || "Por jugar";
}

function hasRealResult(match: ProdeMatch) {
    return match.result_a !== null && match.result_b !== null;
}

function isMatchLocked(match: ProdeMatch) {
    const parsedDate = new Date(match.date);
    const alreadyStarted =
        !Number.isNaN(parsedDate.getTime()) && parsedDate.getTime() <= Date.now();

    const normalizedStatus = match.status.trim().toLowerCase();

    return (
        alreadyStarted ||
        hasRealResult(match) ||
        normalizedStatus === "live" ||
        normalizedStatus === "en vivo" ||
        normalizedStatus === "finished" ||
        normalizedStatus === "finalizado"
    );
}

function getPredictionPoints(
    predA: number,
    predB: number,
    resultA: number,
    resultB: number
) {
    if (predA === resultA && predB === resultB) {
        return 5;
    }

    let points = 0;

    const predictedOutcome = predA > predB ? "A" : predA < predB ? "B" : "D";
    const realOutcome = resultA > resultB ? "A" : resultA < resultB ? "B" : "D";

    if (predictedOutcome === realOutcome) {
        points += 2;
    }

    if (predA === resultA) {
        points += 1;
    }

    if (predB === resultB) {
        points += 1;
    }

    return points;
}

function getPointsLabel(points: number) {
    if (points === 5) return "Pleno";
    if (points >= 3) return "Buen ojo";
    if (points === 2) return "Ganador";
    if (points === 1) return "Gol acertado";
    return "Sin puntos";
}

function getInputClass(hasError: boolean, hasValue: boolean) {
    return [
        "w-full rounded-lg border-4 bg-transparent px-4 py-4 font-['Roboto_Mono',monospace] font-bold text-[#d18381] placeholder:text-[#d18381] transition-colors focus:outline-none",
        hasError
            ? "border-[#ba4643]"
            : hasValue
                ? "border-red-500"
                : "border-[#d18381] focus:border-red-500",
    ].join(" ");
}

export default function ProdeSection({ className = "" }: { className?: string }) {
    const [user, setUser] = useState<ProdeUser | null>(null);

    const [registerUsername, setRegisterUsername] = useState("");
    const [registerEmail, setRegisterEmail] = useState("");
    const [loginEmail, setLoginEmail] = useState("");

    const [registerFieldErrors, setRegisterFieldErrors] = useState<RegisterFieldErrors>({
        username: "",
        email: "",
    });

    const [loginFieldErrors, setLoginFieldErrors] = useState<LoginFieldErrors>({
        email: "",
    });

    const [matches, setMatches] = useState<ProdeMatch[]>([]);
    const [predictions, setPredictions] = useState<
        Record<string, { predA: string; predB: string }>
    >({});
    const [ranking, setRanking] = useState<RankingItem[]>([]);

    const [activeStage, setActiveStage] = useState("");
    const [rankingPage, setRankingPage] = useState(1);

    const [loading, setLoading] = useState(true);
    const [authLoading, setAuthLoading] = useState(false);
    const [matchesLoading, setMatchesLoading] = useState(false);
    const [savingMatchId, setSavingMatchId] = useState<string | null>(null);
    const [savedMatchId, setSavedMatchId] = useState<string | null>(null);
    const [error, setError] = useState("");

    const stageGroups = useMemo(() => {
        const grouped = matches.reduce<Record<string, ProdeMatch[]>>((acc, match) => {
            const stage = match.stage || "Partidos";

            if (!acc[stage]) {
                acc[stage] = [];
            }

            acc[stage].push(match);

            return acc;
        }, {});

        return Object.entries(grouped)
            .map(([stage, stageMatches]) => ({
                stage,
                label: formatStageLabel(stage),
                order: getStageOrder(stage),
                matches: [...stageMatches].sort((a, b) => {
                    const dateA = new Date(a.date).getTime();
                    const dateB = new Date(b.date).getTime();

                    if (Number.isNaN(dateA)) return 1;
                    if (Number.isNaN(dateB)) return -1;

                    return dateA - dateB;
                }),
            }))
            .sort((a, b) => {
                if (a.order !== b.order) {
                    return a.order - b.order;
                }

                const dateA = new Date(a.matches[0]?.date ?? "").getTime();
                const dateB = new Date(b.matches[0]?.date ?? "").getTime();

                if (Number.isNaN(dateA)) return 1;
                if (Number.isNaN(dateB)) return -1;

                return dateA - dateB;
            });
    }, [matches]);

    const activeGroup =
        stageGroups.find((group) => group.stage === activeStage) ?? stageGroups[0];

    const rankingPageCount = Math.max(1, Math.ceil(ranking.length / RANKING_PAGE_SIZE));
    const rankingStartIndex = (rankingPage - 1) * RANKING_PAGE_SIZE;
    const rankingEndIndex = rankingStartIndex + RANKING_PAGE_SIZE;

    const paginatedRanking = useMemo(() => {
        return ranking.slice(rankingStartIndex, rankingEndIndex);
    }, [ranking, rankingStartIndex, rankingEndIndex]);

    useEffect(() => {
        const savedUser = localStorage.getItem(STORAGE_KEY);

        if (savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch {
                localStorage.removeItem(STORAGE_KEY);
            }
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        loadMatches();
        loadRanking();
    }, []);

    useEffect(() => {
        if (user) {
            loadUserPredictions(user.id);
        }
    }, [user]);

    useEffect(() => {
        if (!stageGroups.length) {
            setActiveStage("");
            return;
        }

        const currentStageExists = stageGroups.some((group) => group.stage === activeStage);

        if (!currentStageExists) {
            setActiveStage(stageGroups[0].stage);
        }
    }, [stageGroups, activeStage]);

    useEffect(() => {
        if (rankingPage > rankingPageCount) {
            setRankingPage(rankingPageCount);
        }
    }, [rankingPage, rankingPageCount]);

    async function loadMatches() {
        try {
            setMatchesLoading(true);

            const data = await getProdeMatches();

            setMatches(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error cargando partidos:", error);
            setMatches([]);
            setError("No pudimos cargar los partidos.");
        } finally {
            setMatchesLoading(false);
        }
    }

    async function loadRanking() {
        try {
            const data = await getRanking();

            setRanking(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error cargando ranking:", error);
            setRanking([]);
        }
    }

    async function loadUserPredictions(userId: string) {
        try {
            const data = await getUserPredictions(userId);
            const safeData: Prediction[] = Array.isArray(data) ? data : [];

            const nextPredictions = safeData.reduce<
                Record<string, { predA: string; predB: string }>
            >((acc, prediction) => {
                acc[prediction.match_id] = {
                    predA: String(prediction.pred_a),
                    predB: String(prediction.pred_b),
                };

                return acc;
            }, {});

            setPredictions(nextPredictions);
        } catch (error) {
            console.error("Error cargando predicciones:", error);
            setError("No pudimos cargar tus resultados.");
        }
    }

    async function handleRegister(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        try {
            setError("");
            setRegisterFieldErrors({ username: "", email: "" });

            const cleanUsername = registerUsername.trim().toUpperCase();
            const cleanEmail = registerEmail.trim().toLowerCase();

            const nextErrors: RegisterFieldErrors = {
                username: "",
                email: "",
            };

            if (!cleanUsername) {
                nextErrors.username = "Ingresá tu nombre de jugador.";
            }

            if (!cleanEmail) {
                nextErrors.email = "Ingresá tu email.";
            } else if (!isValidEmail(cleanEmail)) {
                nextErrors.email = "Ingresá un email válido.";
            }

            if (nextErrors.username || nextErrors.email) {
                setRegisterFieldErrors(nextErrors);
                return;
            }

            setAuthLoading(true);

            const [existingEmailUser, existingUsernameUser] = await Promise.all([
                getProdeUserByEmail(cleanEmail),
                getProdeUserByUsername(cleanUsername),
            ]);

            if (existingEmailUser) {
                nextErrors.email = "Este email ya está registrado. Usá recuperar resultados.";
            }

            if (existingUsernameUser) {
                nextErrors.username = "Ese nombre de jugador ya está registrado. Probá con otro.";
            }

            if (nextErrors.username || nextErrors.email) {
                setRegisterFieldErrors(nextErrors);
                return;
            }

            const userData = await getOrCreateProdeUser(cleanUsername, cleanEmail);

            setUser(userData);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
        } catch (error) {
            console.error("Error registrando usuario:", error);
            setError("No pudimos registrarte. Revisá los datos e intentá de nuevo.");
        } finally {
            setAuthLoading(false);
        }
    }

    async function handleLogin(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        try {
            setError("");
            setLoginFieldErrors({ email: "" });

            const cleanEmail = loginEmail.trim().toLowerCase();

            if (!cleanEmail) {
                setLoginFieldErrors({ email: "Ingresá tu email para recuperar tus resultados." });
                return;
            }

            if (!isValidEmail(cleanEmail)) {
                setLoginFieldErrors({ email: "Ingresá un email válido." });
                return;
            }

            setAuthLoading(true);

            const userData = await getProdeUserByEmail(cleanEmail);

            if (!userData) {
                setLoginFieldErrors({ email: "No encontramos un jugador con ese email." });
                return;
            }

            setUser(userData);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
        } catch (error) {
            console.error("Error ingresando:", error);
            setError("No pudimos ingresar. Intentá nuevamente.");
        } finally {
            setAuthLoading(false);
        }
    }

    function handlePredictionChange(
        matchId: string,
        field: "predA" | "predB",
        value: string
    ) {
        const cleanValue = value.replace(/\D/g, "").slice(0, 2);

        setPredictions((current) => ({
            ...current,
            [matchId]: {
                predA: current[matchId]?.predA ?? "",
                predB: current[matchId]?.predB ?? "",
                [field]: cleanValue,
            },
        }));
    }

    async function handleSavePrediction(match: ProdeMatch) {
        try {
            setError("");
            setSavedMatchId(null);

            if (!user) {
                setError("Primero ingresá al Prode.");
                return;
            }

            if (isMatchLocked(match)) {
                setError("Este partido ya está cerrado. No se puede modificar.");
                return;
            }

            const prediction = predictions[match.id];

            if (!prediction || prediction.predA === "" || prediction.predB === "") {
                setError("Completá ambos resultados antes de guardar.");
                return;
            }

            setSavingMatchId(match.id);

            await upsertPrediction({
                userId: user.id,
                matchId: match.id,
                predA: Number(prediction.predA),
                predB: Number(prediction.predB),
            });

            setSavedMatchId(match.id);

            await loadRanking();

            setTimeout(() => {
                setSavedMatchId(null);
            }, 1800);
        } catch (error) {
            console.error("Error guardando predicción:", error);
            setError("No pudimos guardar tu resultado.");
        } finally {
            setSavingMatchId(null);
        }
    }

    async function handleRefreshMatches() {
        try {
            setError("");
            setMatchesLoading(true);

            await syncProdeMatches();
            await loadMatches();
            await loadRanking();

            if (user) {
                await loadUserPredictions(user.id);
            }
        } catch (error) {
            console.error("Error sincronizando partidos:", error);
            setError("No pudimos sincronizar los partidos.");
        } finally {
            setMatchesLoading(false);
        }
    }

    function handleLogout() {
        setUser(null);
        setPredictions({});
        localStorage.removeItem(STORAGE_KEY);
    }

    if (loading) {
        return (
            <section className="relative w-full bg-[#f2f1de] px-4 py-20 sm:px-8 md:px-10 lg:px-10 xl:px-16">
                <p className="font-['Roboto_Mono',monospace] text-[#181819]">
                    Cargando Prode...
                </p>
            </section>
        );
    }

    return (
        <section
            id="prode"
            className={`relative w-full bg-[#f2f1de] px-4 py-14 sm:px-8 sm:py-20 md:px-10 lg:px-10 lg:py-24 xl:px-16 ${className}`}
        >
            <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.06, margin: "0px 0px -8% 0px" }}
                transition={{ duration: 0.55, ease: smoothEase }}
                className="mx-auto max-w-[1920px]"
            >
                <div className="grid grid-cols-1 gap-10 xl:grid-cols-[minmax(0,0.82fr)_minmax(0,1.18fr)] xl:items-center xl:gap-16">
                    <div className="flex w-full min-w-0 max-w-[760px] flex-col justify-center gap-4 self-center">
                        <motion.div
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.08, margin: "0px 0px -10% 0px" }}
                            transition={{
                                duration: 0.45,
                                delay: 0.05,
                                ease: [0.22, 1, 0.36, 1],
                            }}
                            className="w-[clamp(7rem,14vw,13.75rem)]"
                        >
                            <img
                                src={imgMundial}
                                alt="Mundial 2026"
                                className="block h-auto w-full object-contain"
                            />
                        </motion.div>

                        <h2 className="m-0 font-['Excessive_Extra_Condensed'] text-[clamp(5rem,12vw,10.5rem)] leading-[0.9] tracking-[0.02em] text-[#181819]">
                            <span className="block">EL PRODE</span>
                            <span className="block">DE STACY.</span>
                        </h2>

                        <p className="m-0 max-w-[40rem] font-['Roboto_Mono',monospace] text-[clamp(1.1rem,2.2vw,2rem)] leading-[1.14] text-[#181819]">
                            Cargá tus resultados, sumá puntos y jugá el mundial con{" "}
                            <span className="font-bold">equipo, intuición y ganas de ganar.</span>
                        </p>
                    </div>

                    <div className="w-full max-w-[1024px] xl:justify-self-end">
                        <div className="flex w-full flex-col gap-6">
                            <motion.div
                                key="ranking"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
                                className="w-full rounded-[24px] bg-[#113f7f] p-6 text-[#f2f1de] shadow-[0px_14px_64px_0px_rgba(24,24,25,0.12),0px_8px_22px_0px_rgba(24,24,25,0.12)] sm:p-8"
                            >
                                <div className="flex items-center justify-between gap-4">
                                    <p className="m-0 font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#f2f1de]/80">
                                        RANKING
                                    </p>

                                    <p className="m-0 font-['Roboto_Mono',monospace] text-xs text-[#f2f1de]/70">
                                        {ranking.length > RANKING_PAGE_SIZE
                                            ? "10 POR PÁGINA"
                                            : `${ranking.length} JUGADORES`}
                                    </p>
                                </div>

                                <motion.div className="mt-4 flex flex-col gap-2" layout>
                                    {ranking.length ? (
                                        <AnimatePresence mode="popLayout">
                                            {paginatedRanking.map((item, index) => {
                                                const position = rankingStartIndex + index + 1;

                                                return (
                                                    <motion.div
                                                        layout
                                                        key={`${item.user_id ?? item.username ?? item.name ?? position}`}
                                                        className="flex items-center justify-between gap-4 rounded-xl bg-[#f2f1de]/10 px-4 py-3"
                                                        initial={{ opacity: 0, x: 14 }}
                                                        animate={{ opacity: 1, x: 0 }}
                                                        exit={{ opacity: 0, x: -14 }}
                                                        transition={{ duration: 0.28, ease: smoothEase }}
                                                    >
                                                        <span className="truncate font-['Roboto_Mono',monospace] text-xs font-bold uppercase sm:text-sm">
                                                            #{position} {item.username ?? item.name ?? "Jugador"}
                                                        </span>

                                                        <span className="shrink-0 font-['Roboto_Mono',monospace] text-xs font-bold sm:text-sm">
                                                            {Number(item.points) || 0} pts
                                                        </span>
                                                    </motion.div>
                                                );
                                            })}
                                        </AnimatePresence>
                                    ) : (
                                        <p className="m-0 font-['Roboto_Mono',monospace] text-sm leading-6 text-[#f2f1de]/80">
                                            Todavía no hay puntos. El juego recién empieza.
                                        </p>
                                    )}
                                </motion.div>

                                {ranking.length > RANKING_PAGE_SIZE ? (
                                    <div className="mt-4 flex items-center justify-between gap-3 border-t border-[#f2f1de]/15 pt-4">
                                        <motion.button
                                            type="button"
                                            onClick={() => setRankingPage((current) => Math.max(1, current - 1))}
                                            disabled={rankingPage === 1}
                                            whileHover={{ scale: rankingPage === 1 ? 1 : 1.04 }}
                                            whileTap={{ scale: rankingPage === 1 ? 1 : 0.96 }}
                                            className="rounded-lg border border-[#f2f1de]/25 px-3 py-2 font-['Roboto_Mono',monospace] text-[11px] font-bold uppercase tracking-[0.06em] transition hover:bg-[#f2f1de] hover:text-[#113f7f] disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:bg-transparent disabled:hover:text-[#f2f1de]"
                                        >
                                            Anterior
                                        </motion.button>

                                        <p className="m-0 text-center font-['Roboto_Mono',monospace] text-[11px] uppercase tracking-[0.08em] text-[#f2f1de]/75">
                                            Página {rankingPage} / {rankingPageCount}
                                        </p>

                                        <motion.button
                                            type="button"
                                            onClick={() =>
                                                setRankingPage((current) =>
                                                    Math.min(rankingPageCount, current + 1)
                                                )
                                            }
                                            disabled={rankingPage === rankingPageCount}
                                            whileHover={{ scale: rankingPage === rankingPageCount ? 1 : 1.04 }}
                                            whileTap={{ scale: rankingPage === rankingPageCount ? 1 : 0.96 }}
                                            className="rounded-lg border border-[#f2f1de]/25 px-3 py-2 font-['Roboto_Mono',monospace] text-[11px] font-bold uppercase tracking-[0.06em] transition hover:bg-[#f2f1de] hover:text-[#113f7f] disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:bg-transparent disabled:hover:text-[#f2f1de]"
                                        >
                                            Siguiente
                                        </motion.button>
                                    </div>
                                ) : null}
                            </motion.div>

                            <AnimatePresence mode="wait">
                                {!user ? (
                                    <motion.div
                                        key="auth"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
                                        className="w-full rounded-[24px] bg-[#f5f4e5] p-6 shadow-[0px_14px_64px_0px_rgba(24,24,25,0.12),0px_8px_22px_0px_rgba(24,24,25,0.12)] sm:p-8"
                                    >
                                        <div className="flex w-full items-start justify-between gap-4">
                                            <h3 className="m-0 min-w-0 flex-1 font-['Excessive_Extra_Condensed'] text-[clamp(3.5rem,9vw,7.5rem)] leading-[0.9] tracking-[0.02em] text-[#ba4643]">
                                                ENTRÁ AL PRODE
                                            </h3>
                                        </div>

                                        <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-2">
                                           {/*  <form onSubmit={handleRegister} className="min-w-0 space-y-6">
                                                <div>
                                                    <p className="m-0 mb-4 font-['Roboto_Mono',monospace] text-sm font-bold tracking-wider text-[#181819]">
                                                        QUIERO JUGAR
                                                    </p>

                                                    <label className="mb-2 block font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#181819]">
                                                        NOMBRE DE JUGADOR
                                                    </label>

                                                    <input
                                                        type="text"
                                                        value={registerUsername}
                                                        onChange={(event) => {
                                                            setRegisterUsername(event.target.value);
                                                            setError("");
                                                            setRegisterFieldErrors((current) => ({
                                                                ...current,
                                                                username: "",
                                                            }));
                                                        }}
                                                        placeholder="Ej: PRUEBA"
                                                        className={getInputClass(
                                                            Boolean(registerFieldErrors.username),
                                                            Boolean(registerUsername)
                                                        )}
                                                        required
                                                    />

                                                    {registerFieldErrors.username ? (
                                                        <p className="mb-0 mt-2 font-['Roboto_Mono',monospace] text-sm text-[#ba4643]">
                                                            {registerFieldErrors.username}
                                                        </p>
                                                    ) : null}
                                                </div>

                                                <div>
                                                    <label className="mb-2 block font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#181819]">
                                                        EMAIL
                                                    </label>

                                                    <input
                                                        type="email"
                                                        value={registerEmail}
                                                        onChange={(event) => {
                                                            setRegisterEmail(event.target.value);
                                                            setError("");
                                                            setRegisterFieldErrors((current) => ({
                                                                ...current,
                                                                email: "",
                                                            }));
                                                        }}
                                                        placeholder="Ingresa tu email"
                                                        className={getInputClass(
                                                            Boolean(registerFieldErrors.email),
                                                            Boolean(registerEmail)
                                                        )}
                                                        required
                                                    />

                                                    {registerFieldErrors.email ? (
                                                        <p className="mb-0 mt-2 font-['Roboto_Mono',monospace] text-sm text-[#ba4643]">
                                                            {registerFieldErrors.email}
                                                        </p>
                                                    ) : null}
                                                </div>

                                                <motion.button
                                                    type="submit"
                                                    disabled={authLoading}
                                                    whileHover={{ scale: authLoading ? 1 : 1.02 }}
                                                    whileTap={{ scale: authLoading ? 1 : 0.98 }}
                                                    className="flex w-full cursor-pointer items-center justify-center gap-3 rounded-lg border-0 bg-[#113f7f] px-6 py-4 font-['Roboto_Mono',monospace] text-base font-medium tracking-[0.08em] text-[#f2f1de] transition-colors hover:bg-[#0d2f5f] disabled:cursor-not-allowed disabled:opacity-60 sm:text-lg"
                                                >
                                                    {authLoading ? "VALIDANDO..." : "ENTRAR AL PRODE"}
                                                    <ArrowIcon />
                                                </motion.button>
                                            </form> */}

                                            <form onSubmit={handleLogin} className="min-w-0 space-y-6">
                                                <div>
                                                    <p className="m-0 mb-4 font-['Roboto_Mono',monospace] text-sm font-bold tracking-wider text-[#181819]">
                                                        YA JUGUÉ
                                                    </p>

                                                    <label className="mb-2 block font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#181819]">
                                                        EMAIL
                                                    </label>

                                                    <input
                                                        type="email"
                                                        value={loginEmail}
                                                        onChange={(event) => {
                                                            setLoginEmail(event.target.value);
                                                            setError("");
                                                            setLoginFieldErrors({ email: "" });
                                                        }}
                                                        placeholder="Ingresa tu email"
                                                        className={getInputClass(
                                                            Boolean(loginFieldErrors.email),
                                                            Boolean(loginEmail)
                                                        )}
                                                        required
                                                    />

                                                    {loginFieldErrors.email ? (
                                                        <p className="mb-0 mt-2 font-['Roboto_Mono',monospace] text-sm text-[#ba4643]">
                                                            {loginFieldErrors.email}
                                                        </p>
                                                    ) : null}
                                                </div>

                                                <motion.button
                                                    type="submit"
                                                    disabled={authLoading}
                                                    whileHover={{ scale: authLoading ? 1 : 1.02 }}
                                                    whileTap={{ scale: authLoading ? 1 : 0.98 }}
                                                    className="flex w-full cursor-pointer items-center justify-center gap-3 rounded-lg border-0 bg-[#ba4643] px-6 py-4 font-['Roboto_Mono',monospace] text-base font-medium tracking-[0.08em] text-[#f2f1de] transition-colors hover:bg-[#9f3937] disabled:cursor-not-allowed disabled:opacity-60 sm:text-lg"
                                                >
                                                    {authLoading ? "BUSCANDO..." : "VER MIS RESULTADOS"}
                                                    <ArrowIcon />
                                                </motion.button>
                                            </form>
                                        </div>
                                    </motion.div>
                                ) : (
                                    <motion.div
                                        key="active-user"
                                        initial={{ opacity: 0, scale: 0.96 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.98 }}
                                        transition={{ duration: 0.6, ease: smoothEase }}
                                        className="flex w-full flex-col gap-4 rounded-[24px] bg-[#181819] p-6 text-[#f2f1de] shadow-[0px_14px_64px_0px_rgba(24,24,25,0.12),0px_8px_22px_0px_rgba(24,24,25,0.12)] sm:flex-row sm:items-center sm:justify-between sm:p-8"
                                    >
                                        <div>
                                            <p className="m-0 font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#f2f1de]/70">
                                                JUGADOR ACTIVO
                                            </p>

                                            <p className="m-0 mt-2 font-['Roboto_Mono',monospace] text-xl font-bold uppercase">
                                                {user.username}
                                            </p>
                                        </div>

                                        <div className="flex flex-wrap gap-3">
                                            <motion.button
                                                type="button"
                                                onClick={handleRefreshMatches}
                                                disabled={matchesLoading}
                                                whileHover={{ scale: matchesLoading ? 1 : 1.04 }}
                                                whileTap={{ scale: matchesLoading ? 1 : 0.96 }}
                                                className="w-fit rounded-lg border border-[#f2f1de]/40 px-4 py-3 font-['Roboto_Mono',monospace] text-xs font-bold uppercase tracking-[0.04em] transition hover:bg-[#f2f1de] hover:text-[#181819] disabled:cursor-not-allowed disabled:opacity-50"
                                            >
                                                {matchesLoading ? "Actualizando..." : "Actualizar partidos"}
                                            </motion.button>

                                            <motion.button
                                                type="button"
                                                onClick={handleLogout}
                                                whileHover={{ scale: 1.04 }}
                                                whileTap={{ scale: 0.96 }}
                                                className="w-fit rounded-lg border border-[#f2f1de]/40 px-4 py-3 font-['Roboto_Mono',monospace] text-xs font-bold uppercase tracking-[0.04em] transition hover:bg-[#f2f1de] hover:text-[#181819]"
                                            >
                                                Salir
                                            </motion.button>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                </div>

                {user ? (
                    <motion.div
                        className="mt-10 flex flex-col gap-6"
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.58, ease: smoothEase, delay: 0.18 }}
                    >
                        {matchesLoading ? (
                            <motion.div
                                className="rounded-[24px] bg-[#f5f4e5] p-8 font-['Roboto_Mono',monospace] text-[#181819] shadow-[0px_14px_64px_0px_rgba(24,24,25,0.10),0px_8px_22px_0px_rgba(24,24,25,0.08)]"
                                initial={{ opacity: 0, y: 18 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.35, ease: smoothEase }}
                            >
                                Cargando partidos...
                            </motion.div>
                        ) : matches.length === 0 ? (
                            <motion.div
                                className="rounded-[24px] bg-[#f5f4e5] p-6 shadow-[0px_14px_64px_0px_rgba(24,24,25,0.12),0px_8px_22px_0px_rgba(24,24,25,0.12)] sm:p-8"
                                initial={{ opacity: 0, y: 18 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.35, ease: smoothEase }}
                            >
                                <h3 className="m-0 font-['Excessive_Extra_Condensed'] text-[clamp(3.5rem,9vw,7.5rem)] leading-[0.9] tracking-[0.02em] text-[#ba4643]">
                                    TODAVÍA NO HAY PARTIDOS
                                </h3>

                                <p className="mt-4 max-w-[620px] font-['Roboto_Mono',monospace] text-[15px] leading-[24px] text-[#181819]">
                                    Tocá actualizar partidos para sincronizar el fixture desde la API.
                                </p>

                                <motion.button
                                    type="button"
                                    onClick={handleRefreshMatches}
                                    disabled={matchesLoading}
                                    whileHover={{ scale: matchesLoading ? 1 : 1.02 }}
                                    whileTap={{ scale: matchesLoading ? 1 : 0.98 }}
                                    className="mt-6 rounded-lg bg-[#113f7f] px-6 py-4 font-['Roboto_Mono',monospace] text-sm font-bold uppercase tracking-[0.04em] text-[#f2f1de] disabled:opacity-60"
                                >
                                    ACTUALIZAR PARTIDOS
                                </motion.button>
                            </motion.div>
                        ) : (
                            <motion.div
                                className="flex flex-col gap-6"
                                initial={{ opacity: 0, y: 18 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.45, ease: smoothEase }}
                            >
                                <motion.div
                                    className="rounded-[24px] bg-[#f5f4e5] p-3 shadow-[0px_14px_64px_0px_rgba(24,24,25,0.08),0px_8px_22px_0px_rgba(24,24,25,0.08)]"
                                    layout
                                >
                                    <div className="flex gap-2 overflow-x-auto pb-1">
                                        {stageGroups.map((group) => {
                                            const isActive = group.stage === activeGroup?.stage;

                                            return (
                                                <motion.button
                                                    type="button"
                                                    layout
                                                    key={group.stage}
                                                    onClick={() => setActiveStage(group.stage)}
                                                    whileHover={{ scale: 1.03 }}
                                                    whileTap={{ scale: 0.97 }}
                                                    className={[
                                                        "shrink-0 rounded-lg px-4 py-4 text-left font-['Roboto_Mono',monospace] transition",
                                                        isActive
                                                            ? "bg-[#181819] text-[#f2f1de]"
                                                            : "bg-[#181819]/5 text-[#181819] hover:bg-[#181819]/10",
                                                    ].join(" ")}
                                                >
                                                    <span className="block text-xs font-bold uppercase tracking-[0.08em]">
                                                        {group.label}
                                                    </span>

                                                    <span
                                                        className={[
                                                            "mt-1 block text-[11px]",
                                                            isActive ? "text-[#f2f1de]/65" : "text-[#181819]/55",
                                                        ].join(" ")}
                                                    >
                                                        {group.matches.length} partidos
                                                    </span>
                                                </motion.button>
                                            );
                                        })}
                                    </div>
                                </motion.div>

                                <AnimatePresence mode="wait">
                                    {activeGroup ? (
                                        <motion.div
                                            key={activeGroup.stage}
                                            className="flex flex-col gap-6"
                                            initial={{ opacity: 0, y: 18 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -12 }}
                                            transition={{ duration: 0.35, ease: smoothEase }}
                                        >
                                            <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
                                                <div>
                                                    <p className="m-0 font-['Roboto_Mono',monospace] text-xs tracking-wider text-[#ba4643]">
                                                        FIXTURE
                                                    </p>

                                                    <h3 className="m-0 mt-1 font-['Excessive_Extra_Condensed'] text-[clamp(3.5rem,9vw,7.5rem)] leading-[0.9] tracking-[0.02em] text-[#181819]">
                                                        {activeGroup.label}
                                                    </h3>
                                                </div>

                                                <p className="m-0 font-['Roboto_Mono',monospace] text-xs uppercase tracking-[0.08em] text-[#181819]/60">
                                                    Mostrando {activeGroup.matches.length} partidos
                                                </p>
                                            </div>

                                            <motion.div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" layout>
                                                <AnimatePresence mode="popLayout">
                                                    {activeGroup.matches.map((match, index) => {
                                                        const prediction = predictions[match.id] ?? {
                                                            predA: "",
                                                            predB: "",
                                                        };

                                                        const locked = isMatchLocked(match);
                                                        const saved = savedMatchId === match.id;

                                                        const matchPoints =
                                                            hasRealResult(match) &&
                                                                prediction.predA !== "" &&
                                                                prediction.predB !== ""
                                                                ? getPredictionPoints(
                                                                    Number(prediction.predA),
                                                                    Number(prediction.predB),
                                                                    match.result_a as number,
                                                                    match.result_b as number
                                                                )
                                                                : null;

                                                        return (
                                                            <motion.div
                                                                layout
                                                                key={match.id}
                                                                className="rounded-[24px] bg-[#f5f4e5] p-5 shadow-[0px_14px_64px_0px_rgba(24,24,25,0.08),0px_8px_22px_0px_rgba(24,24,25,0.08)]"
                                                                initial={{ opacity: 0, y: 18, scale: 0.98 }}
                                                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                                                exit={{ opacity: 0, y: -10, scale: 0.98 }}
                                                                transition={{
                                                                    duration: 0.35,
                                                                    ease: smoothEase,
                                                                    delay: Math.min(index * 0.035, 0.18),
                                                                }}
                                                                whileHover={{ y: -3 }}
                                                            >
                                                                <div className="flex flex-col gap-4">
                                                                    <div className="flex items-start justify-between gap-3">
                                                                        <p className="m-0 font-['Roboto_Mono',monospace] text-[11px] uppercase tracking-[0.08em] text-[#ba4643]">
                                                                            {formatMatchDate(match.date)}
                                                                        </p>

                                                                        <span className="shrink-0 rounded-full bg-[#181819]/10 px-2.5 py-1 font-['Roboto_Mono',monospace] text-[10px] font-bold uppercase text-[#181819]/70">
                                                                            {locked ? "cerrado" : formatStatusLabel(match.status)}
                                                                        </span>
                                                                    </div>

                                                                    <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-3">
                                                                        <div className="flex min-w-0 items-center justify-end gap-2">
                                                                            <p className="m-0 truncate text-right font-['Roboto_Mono',monospace] text-sm font-bold uppercase text-[#181819]">
                                                                                {match.team_a}
                                                                            </p>

                                                                            <TeamFlag team={match.team_a} />
                                                                        </div>

                                                                        <div className="flex items-center gap-1.5">
                                                                            <input
                                                                                value={prediction.predA}
                                                                                onChange={(event) =>
                                                                                    handlePredictionChange(
                                                                                        match.id,
                                                                                        "predA",
                                                                                        event.target.value
                                                                                    )
                                                                                }
                                                                                disabled={locked}
                                                                                inputMode="numeric"
                                                                                className="h-10 w-10 rounded-lg border-[3px] border-[#d18381] bg-transparent text-center font-['Roboto_Mono',monospace] text-lg font-bold text-[#ba4643] outline-none focus:border-red-500 disabled:opacity-50"
                                                                            />

                                                                            <span className="font-['Roboto_Mono',monospace] text-sm font-bold text-[#ba4643]">
                                                                                -
                                                                            </span>

                                                                            <input
                                                                                value={prediction.predB}
                                                                                onChange={(event) =>
                                                                                    handlePredictionChange(
                                                                                        match.id,
                                                                                        "predB",
                                                                                        event.target.value
                                                                                    )
                                                                                }
                                                                                disabled={locked}
                                                                                inputMode="numeric"
                                                                                className="h-10 w-10 rounded-lg border-[3px] border-[#d18381] bg-transparent text-center font-['Roboto_Mono',monospace] text-lg font-bold text-[#ba4643] outline-none focus:border-red-500 disabled:opacity-50"
                                                                            />
                                                                        </div>

                                                                        <div className="flex min-w-0 items-center gap-2">
                                                                            <TeamFlag team={match.team_b} />

                                                                            <p className="m-0 truncate font-['Roboto_Mono',monospace] text-sm font-bold uppercase text-[#181819]">
                                                                                {match.team_b}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    {match.result_a !== null && match.result_b !== null ? (
                                                                        <div className="rounded-xl bg-[#181819]/5 px-3 py-2">
                                                                            <p className="m-0 text-center font-['Roboto_Mono',monospace] text-xs text-[#181819]/70">
                                                                                Resultado real:{" "}
                                                                                <strong>
                                                                                    {match.result_a} - {match.result_b}
                                                                                </strong>
                                                                            </p>

                                                                            {matchPoints !== null ? (
                                                                                <p className="m-0 mt-1 text-center font-['Roboto_Mono',monospace] text-xs font-bold text-[#ba4643]">
                                                                                    +{matchPoints} pts · {getPointsLabel(matchPoints)}
                                                                                </p>
                                                                            ) : null}
                                                                        </div>
                                                                    ) : null}

                                                                    {saved ? (
                                                                        <motion.p
                                                                            className="m-0 text-center font-['Roboto_Mono',monospace] text-xs font-bold text-[#ba4643]"
                                                                            initial={{ opacity: 0, y: 6 }}
                                                                            animate={{ opacity: 1, y: 0 }}
                                                                            transition={{ duration: 0.25, ease: smoothEase }}
                                                                        >
                                                                            Resultado guardado.
                                                                        </motion.p>
                                                                    ) : null}

                                                                    <motion.button
                                                                        type="button"
                                                                        onClick={() => handleSavePrediction(match)}
                                                                        disabled={locked || savingMatchId === match.id}
                                                                        whileHover={{
                                                                            scale: locked || savingMatchId === match.id ? 1 : 1.01,
                                                                        }}
                                                                        whileTap={{
                                                                            scale: locked || savingMatchId === match.id ? 1 : 0.99,
                                                                        }}
                                                                        className="flex min-h-[44px] items-center justify-center rounded-lg bg-[#113f7f] px-4 py-3 font-['Roboto_Mono',monospace] text-xs font-bold uppercase tracking-[0.04em] text-[#f2f1de] transition hover:bg-[#0d2f5f] disabled:cursor-not-allowed disabled:opacity-50"
                                                                    >
                                                                        {locked
                                                                            ? "Partido cerrado"
                                                                            : savingMatchId === match.id
                                                                                ? "Guardando..."
                                                                                : "Guardar resultado"}
                                                                    </motion.button>
                                                                </div>
                                                            </motion.div>
                                                        );
                                                    })}
                                                </AnimatePresence>
                                            </motion.div>
                                        </motion.div>
                                    ) : null}
                                </AnimatePresence>
                            </motion.div>
                        )}
                    </motion.div>
                ) : null}

                <AnimatePresence>
                    {error ? (
                        <motion.div
                            className="mt-6 rounded-2xl border-2 border-[#ba4643] bg-[#ba4643]/10 px-5 py-4 font-['Roboto_Mono',monospace] text-sm font-bold text-[#ba4643]"
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -8 }}
                            transition={{ duration: 0.25, ease: smoothEase }}
                        >
                            {error}
                        </motion.div>
                    ) : null}
                </AnimatePresence>
            </motion.div>
        </section>
    );
}